import { IconContent } from '../style';

const Remove = () => (
  <IconContent fill='currentColor' viewBox='0 0 24 24'>
    <path d='M19 13H5v-2h14v2z' />
  </IconContent>
);

export default Remove;
